// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.enterprise.events.RentalManagerEnterpriseEventTrackingWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { EnterpriseListingEvent } from '../..';

interface TrackCustomerListingEventParams {
  event: EnterpriseListingEvent;
  feedId: string;
  feedListingId: string;
}

export const RentalManagerEnterpriseEventTrackingWebApiHandler_trackCustomerListingEvent_Path =
  '/api/web/v1/users/enterprise/events/trackCustomerListingEvent';

/**
 * Track enterprise listing event
 */
export const RentalManagerEnterpriseEventTrackingWebApiHandler_trackCustomerListingEvent = (
  getParams: TrackCustomerListingEventParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<TrackCustomerListingEventParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerEnterpriseEventTrackingWebApiHandler_trackCustomerListingEvent_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
